module.exports = __webpack_public_path__ + "media/assets/svgs/lock-b98636e5c9284a4e7375dc0d95403e51.svg";